import React from 'react'

export default function Info({ className }) {
    return (
        <svg
            className={className}
            height="31px"
            version="1.1"
            viewBox="0 0 31 31"
            width="31px"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g
                id="Udala-Zabaltzen-0"
                stroke="none"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd"
            >
                <g
                    id="AurreTIK_desktop_detalle"
                    transform="translate(-995.000000, -541.000000)"
                >
                    <g
                        id="Group-4"
                        transform="translate(595.000000, 512.000000)"
                    >
                        <g
                            id="Group-7-Copy-2"
                            transform="translate(395.000000, 24.000000)"
                        >
                            <g
                                id="Group"
                                transform="translate(6.000000, 6.000000)"
                            >
                                <circle
                                    id="Oval"
                                    stroke="#065464"
                                    strokeWidth="1.34999996"
                                    cx="14.5"
                                    cy="14.5"
                                    r="14.5"
                                />
                                <path
                                    d="M17.9079368,20.895862 L17.6786674,21.8275913 C16.9908593,22.0974756 16.4414364,22.3028858 16.0323105,22.4441145 C15.6227434,22.5857818 15.1468514,22.65625 14.6046345,22.65625 C13.7719705,22.65625 13.1243103,22.4534713 12.6623892,22.0506917 C12.2004681,21.646304 11.969434,21.1338748 11.969434,20.5122345 C11.969434,20.2715902 11.986199,20.0240745 12.0210527,19.7718803 C12.0562004,19.5193938 12.1120839,19.2350358 12.1885561,18.9171982 L13.0481323,15.8926232 C13.1246045,15.603002 13.1896058,15.3285856 13.2416657,15.0690815 C13.2944608,14.8111856 13.3199025,14.5739038 13.3199025,14.3603064 C13.3199025,13.9740474 13.2394597,13.7038707 13.0793094,13.5519694 C12.9191591,13.4005068 12.6135647,13.3236058 12.159879,13.3236058 C11.9376686,13.3236058 11.7092816,13.3589861 11.4764828,13.4274075 C11.2426545,13.4961212 11.0427975,13.5624958 10.875,13.624192 L11.1048576,12.6917317 C11.6679573,12.4638067 12.2062035,12.2686304 12.7210669,12.1066413 C13.2359302,11.9442137 13.7224107,11.8629268 14.1825671,11.8629268 C15.0094956,11.8629268 15.6475968,12.0616119 16.0956941,12.4589821 C16.5437915,12.8566447 16.7677666,13.3721441 16.7677666,14.0073808 C16.7677666,14.1388142 16.7530604,14.3703942 16.7214421,14.7013898 C16.6905591,15.0331164 16.633058,15.3370652 16.5492327,15.6135284 L15.693333,18.6259688 C15.6231845,18.8679289 15.560095,19.1445384 15.505241,19.4557971 C15.4486222,19.765009 15.4215628,20.0012673 15.4215628,20.1597476 C15.4215628,20.5597494 15.5112705,20.83285 15.6911271,20.9780261 C15.8723072,21.1232022 16.1843724,21.1954247 16.6276167,21.1954247 C16.8357091,21.1954247 17.0724787,21.1587287 17.3355722,21.0866523 C17.5979305,21.014576 17.7892579,20.9512716 17.9079368,20.895862 Z M18.125,8.2487293 C18.125,8.77358545 17.9260254,9.22183307 17.5261643,9.59040198 C17.1273327,9.96028667 16.6467347,10.1453752 16.0845174,10.1453752 C15.5205354,10.1453752 15.0387609,9.96028667 14.6353704,9.59040198 C14.2327152,9.22168687 14.0309464,8.77358545 14.0309464,8.2487293 C14.0309464,7.72489654 14.2327152,7.27591792 14.6353704,6.90267063 C15.0380256,6.53000814 15.5206825,6.34375 16.0845174,6.34375 C16.6465877,6.34375 17.1273327,6.53044674 17.5261643,6.90267063 C17.9263195,7.27591792 18.125,7.72504274 18.125,8.2487293 Z"
                                    id="Shape"
                                    fill="#1AAFCC"
                                    fillRule="nonzero"
                                />
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    )
}
